export default "__VITE_ASSET__467f5518__"